import { useGraphQLQuery } from '@betterment/graphql';

import { PortfolioSelectionUseQueryResult, WeightedSecuritiesQueryResult } from './data';
import { ExternallyAdvisedPlanPortfolioForGoalDocument } from './graphql/query.externallyAdvisedPlanPortfolioForGoal.generated';
import { WeightedSecuritiesAllocationsForGoalDocument } from './graphql/query.weightedSecuritiesAllocationsForGoal.generated';

export const useExternallyAdvisedPlanPortfolioQuery = (goalId: string): PortfolioSelectionUseQueryResult => {
  const { data } = useGraphQLQuery(ExternallyAdvisedPlanPortfolioForGoalDocument, {
    variables: { goalId },
    throwOnError: true,
  });

  const isLoading = !data;

  const portfolio = data?.goal?.portfolio;
  const qdiaFund = portfolio && 'qdiaFund' in portfolio ? portfolio.qdiaFund : undefined;
  const weightedSecurities = portfolio && 'weightedSecurities' in portfolio ? portfolio.weightedSecurities : undefined;
  const accountId = data?.goal?.envelope?.accounts?.[0]?.id;

  return {
    isLoading,
    qdiaFund,
    weightedSecurities,
    accountId,
  };
};

export const useWeightedSecuritiesForGoalQuery = (goalId: string): WeightedSecuritiesQueryResult => {
  const { data } = useGraphQLQuery(WeightedSecuritiesAllocationsForGoalDocument, {
    variables: { goalId },
    throwOnError: true,
  });

  const isLoading = !data;

  const portfolio = data?.goal?.portfolio;
  const qdiaFund = portfolio && 'qdiaFund' in portfolio ? portfolio.qdiaFund : undefined;
  const weightedSecurities = portfolio && 'weightedSecurities' in portfolio ? portfolio.weightedSecurities : undefined;

  return {
    isLoading,
    qdiaFund,
    weightedSecurities,
  };
};
